module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"error":"error","success":"Success","yes":"Yes","no":"No"},"zh_hk":{"error":"錯誤","success":"成功","yes":"是","no":"否"},"zh_cn":{"error":"错误","success":"成功","yes":"是","no":"否"}}')
  delete Component.options._Ctor
}
